import { NdtStep } from "./helpers";

export default function() {
    return NdtStep('step3', 'Step 3: Are all employees eligible to participate in the pre-tax plan? ("All employees" refers to all Full-Time and Part-Time Employees.)', {
        nextComponent() {
            if(this.answer === true) {
                this.answers.step3a = null;
                return 'step4';
            }

            return 'step3a';
        },
        passed: () => true
    })
}


// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/step3.js